import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=12c361d4&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c361d4')) {
      api.createRecord('12c361d4', component.options)
    } else {
      api.reload('12c361d4', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=12c361d4&", function () {
      api.rerender('12c361d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/notifications.vue"
export default component.exports